// extracted by mini-css-extract-plugin
export default {"app":"FQ0Y5","scrollable":"_1QrQU"};